/**
 * Gaucho House header menu: a top-level item without a URL (e.g. "Info") is only a dropdown
 * trigger. It carries `data-gh-no-nav` (blocks/_header-menu.liquid); clicking or pressing Enter on
 * it opens or closes its dropdown through Horizon's own disclosure button instead of navigating.
 * Hover and keyboard focus keep working as in Horizon (header-menu.js).
 */
document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('[data-gh-no-nav]') : null;
  if (!link) return;

  event.preventDefault();
  const disclosure = link.closest('.menu-list__trigger')?.querySelector('.menu-list__disclosure');
  if (disclosure instanceof HTMLElement) disclosure.click();
});

/**
 * Desktop dropdowns hang from their parent item: before one opens (hover or keyboard focus) the
 * panel gets `--gh-dropdown-left`, the left edge of its parent relative to the header row.
 */
const placeDropdown = (event) => {
  const item = event.target instanceof Element ? event.target.closest('.menu-list__list-item') : null;
  const submenu = item?.querySelector(':scope > .menu-list__submenu');
  if (!(submenu instanceof HTMLElement) || !submenu.offsetParent) return;

  const left = item.getBoundingClientRect().left - submenu.offsetParent.getBoundingClientRect().left;
  submenu.style.setProperty('--gh-dropdown-left', `${Math.max(0, Math.round(left))}px`);
};

document.addEventListener('pointerover', placeDropdown, { passive: true });
document.addEventListener('focusin', placeDropdown);

/**
 * Keyboard: tabbing onto a top-level item that has a dropdown opens it (Horizon only reveals a
 * chevron button there). Tab again reaches the chevron and then the links; Esc closes it.
 */
document.addEventListener('focusin', (event) => {
  const link = event.target;
  if (!(link instanceof HTMLElement) || !link.matches('.menu-list__link:focus-visible')) return;

  const disclosure = link.closest('.menu-list__trigger')?.querySelector('.menu-list__disclosure');
  if (disclosure instanceof HTMLElement && disclosure.getAttribute('aria-expanded') === 'false') disclosure.click();
});
